var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M8,2L1,14.1h14L8,2z M8.4,12.1c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3 c0-0.1,0-0.3,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3S8.5,12,8.4,12.1z M7.6,10.5V6.9h1v3.6 H7.6z","fill":"#f1c13b"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }